<template>
  <div class="psCalendar view">
    <ps-page-container :site="{ site: 'Calendario' }"></ps-page-container>
    <ps-event-dialog
      :visible.sync="eventDialogVisible"
      :title="editingEvent ? 'Editar evento' : 'Nuevo evento'"
      :patient="editingEvent ? null : selectedPatient"
      :event="editingEvent ? calendarItem : null"
      @save="saveAllEvents"
      @delete="deleteEvent"
    />
  </div>
</template>

<script>
import PsPageContainer from '@/components/layout/PsPageContainer.vue'
import PsEventDialog from '@/shared/components/PsEventDialog.vue'
import calendarEventsMixin from '@/shared/mixins/calendarEventsMixin'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsCalendar',
  components: { PsPageContainer, PsEventDialog },
  mixins: [calendarEventsMixin],
  data () {
    return {
      targetPatients: []
    }
  },
  computed: {
    ...mapState('calendar', ['newEventDialogVisible', 'calendarItem']),
    eventDialogVisible: {
      get () { return this.newEventDialogVisible },
      set (value) { this.CALENDAR_NEW_EVENT_DIALOG_VISIBLE(value) }
    },
    editingEvent () {
      return this.calendarItem && this.calendarItem.calendarId > 0
    },
    selectedPatient () {
      if (!this.calendarItem || !this.calendarItem.patientId || this.calendarItem.patientId == 0) return null
      return {
        patientId: this.calendarItem.patientId,
        value: this.calendarItem.patient
      }
    }
  },
  methods: {
    ...mapMutations('calendar', ['CALENDAR_NEW_EVENT_DIALOG_VISIBLE']),
    ...mapActions('calendar', ['getCalendarHTTP', 'deleteCalendarEventHTTP']),
    afterEventsSaved () {
      this.getCalendarHTTP()
    },
    async saveAllEvents ( events ) {
      debugger
      for (const event of events) {
        console.log(event)
        await this.saveEvents(event)
      }
      this.CALENDAR_NEW_EVENT_DIALOG_VISIBLE(false);
      this.afterEventsSaved();
    },
    deleteEvent () {
      this.$confirm('¿Confirma eliminar este evento?', 'Advertencia', {
        type: 'warning',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      })
      .then( async () => {
        await this.deleteCalendarEventHTTP()
        this.$message.success('Evento eliminado!')
        await this.getCalendarHTTP()
      })
      .catch( () => null )
      .finally(() => this.CALENDAR_NEW_EVENT_DIALOG_VISIBLE(false))
    }
  }
}
</script>

<style scoped>

</style>
